'use client'

import { Icon } from '@vinted/web-ui'
import { ArrowRight24, ArrowLeft24 } from '@vinted/monochrome-icons'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import SliderWrapper from '../../../../components/SliderWrapper/SliderWrapper'
import Card from './Card'

const ValuePropositionSection = () => {
  const translate = useTranslate('item_verification')

  const slidesLink = {
    1: translate('url.cta'),
    2: translate('url.help'),
    3: translate('url.help'),
  }

  const sliderCardObjects = Array.from({ length: 3 }, (_, index) => index + 1).map(
    contentItemOrder => ({
      imageFileName: `illustration-${contentItemOrder}`,
      title: `card_${contentItemOrder}.title`,
      description: `card_${contentItemOrder}.description`,
      action: `card_${contentItemOrder}.action`,
      url: slidesLink[contentItemOrder],
      testId: `valueproposition_item-${contentItemOrder}`,
    }),
  )

  return (
    <section className="item-verification__value-proposition" data-testid="valueproposition">
      <div className="item-verification__value-proposition-content">
        <h2 className="item-verification__value-proposition-title">
          {translate('value_proposition.title')}
        </h2>
      </div>
      <div className="item-verification__value-proposition-content item-verification__value-proposition-content--slider">
        <SliderWrapper
          childData={sliderCardObjects}
          childComponent={Card}
          nextButton={<Icon name={ArrowRight24} />}
          previousButton={<Icon name={ArrowLeft24} />}
        />
      </div>
    </section>
  )
}

export default ValuePropositionSection
